<template>
  <div>
    <v-checkbox
      :value="value"
      color="primary"
      hide-details
      v-if="isAlreadyCheck"
      @change="
        $emit('input', !value);
        $emit('change', !value);
      "
    ></v-checkbox>
    <v-dialog
      persistent
      :fullscreen="$vuetify.breakpoint.xs"
      v-model="dialog"
      width="500"
      v-else
    >
      <template v-slot:activator="{ on }">
        <v-checkbox
          v-on="on"
          v-model="value"
          color="primary"
          hide-details
        ></v-checkbox>
        <v-snackbar v-model="snackbar" color="black" :timeout="3000">
          <v-icon color="red">close</v-icon> มีบางอย่างผิดพลาด!
          <v-btn dark flat @click="snackbar = false"> Close </v-btn>
        </v-snackbar>
      </template>

      <v-card>
        <v-card-title class="headline primary py-2" primary-title>
          สิทธิเข้าใช้งานฟังก์ชัน <v-spacer></v-spacer>
          <v-btn
            icon
            @click="
              dialog = false;
              $emit('onClose');
            "
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <div></div>
        <v-card-text>
          <div>
            มีการกำหนดสิทธิการเข้าใช้งานฟังก์ชันนี้
            โปรดขอรหัสยืนยันจากเบอร์โทรศัพท์
            <span style="color: grey; font-weight: bold"> 0{{ otpTel }}</span>
          </div>
          <div class="mb-2" style="color: red" v-if="otpCreatedAt">
            <div>OTP จะหมดเวลาภายใน 5 นาที</div>
            <div>ส่งเมื่อ {{ otpCreatedAt }}</div>
          </div>
          <transition name="bounce" mode="out-in">
            <div key="1" v-if="currentStep == 1" class="text-xs-center">
              <v-btn dark @click="requestOTP()" :loading="requesting"
                >Request OTP</v-btn
              >
            </div>
            <div key="2" v-else>
              <v-form
                ref="form"
                style="border: 1px solid grey; border-radius: 10px"
                class="pa-3"
              >
                <v-text-field
                  disabled
                  label="รหัสอ้างอิง"
                  v-model="otpReferenceId"
                  :rules="[(v) => !!v || 'กรุณากรอก']"
                ></v-text-field>
                <v-text-field
                  @input="
                    isValid = null;
                    verifying = true;
                    debounceInput();
                  "
                  v-model="userPin"
                  label="รหัสยืนยัน"
                  :rules="[(v) => !!v || 'กรุณากรอก']"
                >
                  <template v-slot:append>
                    <v-fade-transition leave-absolute>
                      <v-progress-circular
                        v-if="verifying"
                        size="24"
                        color="info"
                        indeterminate
                      ></v-progress-circular>
                      <v-icon v-else-if="isValid == true" color="success"
                        >check</v-icon
                      >
                      <v-icon v-else-if="isValid == false" color="error"
                        >close</v-icon
                      >
                    </v-fade-transition>
                  </template></v-text-field
                >
                <div class="text-xs-center">
                  <v-btn
                    @click="submit()"
                    :disabled="!isValid"
                    color="black"
                    style="color: white"
                    >ยืนยัน</v-btn
                  >
                </div>
              </v-form>
            </div>
          </transition>
        </v-card-text>

        <v-divider></v-divider>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import _ from "lodash";
export default {
  props: {
    value: {
      type: Boolean,
    },
    otpTel: {
      default() {
        return "";
      },
    },
    isAlreadyCheck: {
      default() {
        return false;
      },
    },
  },
  data() {
    return {
      dialog: false,
      currentStep: 1,
      passwordOTP: "",
      otpReferenceId: "",
      userPin: "",
      snackbar: false,
      requesting: false,
      verifying: false,
      isValid: null,
      otpCreatedAt: null,
    };
  },
  watch: {
    dialog() {
      if (this.dialog == true) {
        this.requesting = false;
        this.verifying = false;
        this.isValid = null;
        this.otpCreatedAt = null;
        this.userPin = "";
        this.otpReferenceId = "";
        this.passwordOTP = "";
        this.currentStep = 1;
      }
    },
  },
  components: {},
  methods: {
    ...mapActions({
      sendOTP: "fetchUserBack/sendOTP",
      verifyOTP: "fetchUserBack/verifyOTP",
    }),
    debounceInput: _.debounce(async function (e) {
      let result = await this.verifyOTP({
        tel: this.otpTel,
        pin: this.userPin,
        ref: this.otpReferenceId,
      });
      this.isValid = result.msg;
      this.verifying = false;
    }, 1000),
    submit() {
      if (this.$refs.form.validate()) {
        this.$emit("input", !this.value);
        this.$emit("change", {
          status: !this.value,
          otp_tel: this.otpTel,
          otp_pin: this.userPin,
          otp_ref: this.otpReferenceId,
          created_at: this.otpCreatedAt,
        });
        this.dialog = false;
      }
    },
    async requestOTP() {
      if (this.otpTel != "") {
        this.requesting = true;
        let result = await this.sendOTP({ tel: this.otpTel });
        if (result !== false) {
          this.currentStep = 2;
          this.otpReferenceId = result.ref;
          this.otpCreatedAt = new Date();
        } else {
          this.snackbar = true;
        }
        this.requesting = false;
      }
    },
  },
  computed: {},
};
</script>

<style  scoped>
.bounce-enter-active {
  animation: bounce-in 0.5s;
}
.bounce-leave-active {
  animation: bounce-in 0.5s reverse;
}
@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  /* 50% {
    transform: scale(1.5);
  } */
  100% {
    transform: scale(1);
  }
}
</style>

